import { orderBy, flatten } from 'lodash';
import { ColumnsType } from 'antd/lib/table';
import { getColumnFilteredValue, getColumnSortOrder } from '../../components/table/columnFormatHelpers';
import { SiteUtility } from '../../components/site/SiteUtility';
import { compareWithLocale } from '../compareWithLocale';
import { ISite } from './interface';

export const getUtilityFilterValue = (state: any) => {
    let { filteredValue } = getColumnFilteredValue('site_utility', state?.filter || {});
    if (Array.isArray(filteredValue)) {
        filteredValue = flatten(filteredValue).map(utilityName => utilityName.toString());
    }
    return filteredValue;
};

export function buildSiteUtilityTableFilter(state: any, utilities: string[], isSidebarEnabled: boolean = false) {
    const column: ColumnsType<ISite>[number] = {
        title: 'Utility',
        dataIndex: 'site_utility',
        sorter: (a, b) => compareWithLocale(a.site_utility, b.site_utility),
        ...getColumnSortOrder('site_utility', state.sorter),
        render: (text, _record) => <SiteUtility siteUtility={text} />,

        ...(isSidebarEnabled
            ? { filtered: false }
            : {
                  filterMultiple: true,
                  filters: orderBy(
                      utilities.map(utility => ({ text: utility, value: utility })),
                      'text'
                  ),
                  filteredValue: getUtilityFilterValue(state),
                  filterSearch: (input, record) => !!record?.text?.toString()?.toLowerCase().includes(input.toLowerCase()),
              }),
    };

    return column;
}
